import React from "react";
import PropTypes from "prop-types";
import styles from "./showFields.module.css";
import { localizedField } from "../../../shared/multilingualism/localized";

function Headline({ property }) {
  return (
    <div className={styles.Headline}>
      {React.createElement(
        `h${property.size || "3"}`,
        null,
        localizedField(property, "label"),
      )}
    </div>
  );
}
Headline.propTypes = {
  property: PropTypes.shape({
    label: PropTypes.string,
    size: PropTypes.number,
  }),
};

export default Headline;
